module.exports = "/shifts/components/eventTinyComponent-bca1a6.html";